/**
 * WORLD cinematic shot registry — the five named ShotDefs QA screenshots.
 * Yaw convention: 0 faces -Z, positive turns left (CCW from above).
 */
import type { DebugRegistry, ShotDef } from '../core/types'

const SHOTS: readonly ShotDef[] = [
  // Low and diagonal down the wet street: camera near head height, rotated
  // so the street runs diagonally through frame; the silhouetted figure
  // stands in the near lamp pool, neon glowing in the distance.
  {
    name: 'street-wide',
    position: { x: -6.5, y: 2.1, z: 33 },
    yaw: -0.42,
    pitch: 0.02
  },
  // "THE BLUE DAHLIA" riding the upper-left third, off-axis from below so
  // the sign reads as a frame, not an asset preview.
  {
    name: 'neon-close',
    position: { x: 6.0, y: 2.0, z: -9.8 },
    yaw: -1.2,
    pitch: 0.34
  },
  // Inside the office at desk height: window spilling frame-left, slats
  // raking across the desk to the lamp's small lit island frame-right.
  {
    name: 'office-blinds',
    position: { x: 35.2, y: 1.3, z: -2.6 },
    yaw: -2.2,
    pitch: -0.04
  },
  // Matchbook centered in its pool of light, inside interact range so the
  // crosshair prompt renders; neon sign cropped fully out of frame.
  // Knee height, 1.3 m out, aimed dead at the matchbook (7.4, 0.17, -10.6):
  // the lit clue fills the lower third, darkness fills the top of frame.
  {
    name: 'clue-interact',
    position: { x: 6.6, y: 0.7, z: -9.6 },
    yaw: -0.67,
    pitch: -0.39
  },
  // Title mood: across the rain-slick road toward the neon.
  {
    name: 'title',
    position: { x: -8, y: 5, z: -24 },
    yaw: -2.17,
    pitch: -0.02
  }
]

export const registerShots = (debug: DebugRegistry): void => {
  SHOTS.forEach((shot) => {
    debug.registerShot(shot)
  })
}
